export default {
    "created": "Comanda a fost creata cu succes",
    "updated": "Comanda a fost actualizata cu succes",
    "deleted": "Comanda a fost ștearsa cu succes",
    "restored": "Comanda a fost restaurata cu succes",
}
